import { Routes } from "react-router-dom";

import { PublicRoutes } from "./publicRoutes";
import { AppRoutes } from "./appRoutes";
import { CustomPageRoutes } from "./customPageRoutes";

export const AppRouter = ({ user }) => (
  <Routes>
    {PublicRoutes}
    {AppRoutes({ user })}
    {CustomPageRoutes}
  </Routes>
);
